module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Sensei Nathan Chlumsky was contacted by Strathmore Worldwide in October 2019 after being nominated by someone and is now in Strathmore’s "), _c('em', [_vm._v("Who’s Who Worldwide 2019 Edition")]), _vm._v(" as being ‘professional of the year in martial arts instruction and historical research.’ Strathmore lists the top professionals of any field, every year, of which the book is meant to be used as a source of contact and communication with other professionals of the same and/or similar field. Also, on October 23, 2020, author’s picture congratulating the accomplishment with Strathmore was featured on the famous eight-story tall Thomas Reuter Billboard in Times Square, located in New York, for 24 hours.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0